import { Component, Input } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { postInContext } from 'src/logic/post-states'
import { Post } from '../../submissions/submission.queries'

const plagiarismWarning = `<!-- This content has not yet been purchased. Any attempt to copy or publish it is plagiarism. Verblio has automated systems in place to detect such misuse. -->`

@Component({
  selector: 'post-preview',
  styles: [`
    :host {
      display: block;
    }
  `],
  template: `
    <div class="post-content tiny-top-buffer"
        [innerHtml]="postContent"
        [class.no-select]="!textSelectable"></div>
  `
})
export class PostPreview {
  @Input() post: Post;

  constructor(private sanitizer: DomSanitizer) {}

  get textSelectable(): boolean {
    return postInContext(this.post, 'purchased')
  }

  get expandable(): boolean {
    return postInContext(this.post, 'expandable')
  }

  get postContent(): SafeHtml {
    let word_count = `<p class='text-right text-sm text-muted font-weight-light'>
        <i><small class="word-count">${this.post.wordCount} words</small></i>
      </p>`
    let content = this.post.content + word_count
    if (!this.textSelectable) {
      content = plagiarismWarning + content + plagiarismWarning
    }
    return this.sanitizer.bypassSecurityTrustHtml(content)
  }
}
